import React from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import { verification } from '../../Constant'

function StorPayment() {
  return (
    <>
    <Header />
    <div className="container">
        <div id="verificationlogin" className="row justify-content-center align-items-center py-5">
            <div id="login-column" className="col-md-8 ">
                <div id="verification" className="col-md-12 py-5">
                    <form id="login-form" className="form" action="" method="post">
                        <h3 className="text-center text-signin bottom-border ">
                            <img src={verification} /></h3>
                        <h3 className="text-center blue">Card Added Successfully</h3>
                        <p></p>
                        <div id="register-link" className="text-center py-2">
                            <a href="index.php" name="submit" className="btn btn-blue text-white" value="">Go back to Homepage</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <Footer />
    </>
  )
}

export default StorPayment